import React from 'react'
import Loader from 'react-loader-spinner'

const Spinner = ({ message }) => {
    return (
        <div className="flex flex-col justify-center items-center w-full h-full" >
            <Loader
                type="MutatingDots"
                color="#ee3454"
                secondaryColor="#16bdd2"
                height={100}
                width={100}
                className=""
            />
            <p className="text-lg text-center px-2"> {message}</p>
        </div>
    )
}

export default Spinner
